module.exports = __webpack_public_path__ + "static/media/icon_airconditioner.05bb1cf5.svg";